export default __webpack_public_path__ + "static/media/employers.03c97ec4.svg";